import React from 'react'
import HomeMenu from '../components/HomeMenu'

export default function HomePage() {
  return <HomeMenu />
}
